"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getOrderList = getOrderList;
exports.getReturnList = getReturnList;
var _createRequest = _interopRequireDefault(require("./createRequest"));
var _interceptors = require("./interceptors");
var fetch = (0, _createRequest.default)({
  timeout: 10000,
  env: 'live'
});
fetch.interceptors.response.use(_interceptors.handleSuccess, _interceptors.handleError);
function getOrderList(params) {
  return fetch.post('/ordercard/v1/order_list', params);
}
function getReturnList(params) {
  return fetch.post('/ordercard/v1/return_list', params);
}
var _default = fetch;
exports.default = _default;